import React from 'react';
import PropTypes from 'prop-types';

import Input from '../Input';
import InputLabelWrapper from '../InputLabelWrapper';

const InputTextGeneric = ({ id, label, isSortable, sortDirection, onLabelClick, value, onChange, type }) => {
  return (
    <InputLabelWrapper
      label={label}
      isSortable={isSortable}
      sortDirection={sortDirection}
      onLabelClick={onLabelClick}
    >
      {value != "none" &&
        (<Input
          id={id}
          className="mt-2"
          type={type}
          containerClassName="mr-2"
          value={value}
          onChange={event => {
            onChange(event.target.value);
          }}
        />)}
      {value == "none" &&
        (<Input
          id={id}
          className="mt-2"
          type={type}
          containerClassName="mr-2"
          onChange={event => {
            onChange(event.target.value);
          }}
        />)
      }

    </InputLabelWrapper>
  );
};

InputTextGeneric.defaultProps = {
  value: '',
  isSortable: false,
  onLabelClick: () => { },
  sortDirection: 'none',
};

InputTextGeneric.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  isSortable: PropTypes.bool,
  sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']),
  onLabelClick: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default InputTextGeneric;
